exports.UV_DATE_FORMAT = "DD/MM/YYYY";
exports.SPANNER_DATE_FORMAT = "YYYY-MM-DD";
exports.DMY_FORMAT = "DD-MM-YYYY";
exports.SPANNER_TIME_FORMAT = "hh:mm:ss";
exports.TIME_FORMAT = "HH:mm";
exports.ISO8601_DATE_FORMAT = "YYYY-MM-DDThh:mm:ss";
exports.CLOCK_09 = "9:00";
exports.EUROPE_LONDON_TIME_ZONE = "Europe/London";
